module.exports = __webpack_public_path__ + "fonts/iconc77332f603c38a787040215d965ac5c4.woff2]";